import { gql } from "@apollo/client";

export const addMqttBrokerSetting = gql`
    mutation addMqttBrokerSetting($setting: mqtt_broker_settings_insert_input!) {
        insert_mqtt_broker_settings_one(object: $setting) {
            id
        }
    }
`;

export const updateMqttBrokerSetting = gql`
    mutation updateMqttBrokerSetting($id: Int!, $setting: mqtt_broker_settings_set_input!) {
        update_mqtt_broker_settings_by_pk(pk_columns: { id: $id }, _set: $setting) {
            id
        }
    }
`;
